import { render, staticRenderFns } from "./TraceabilitySampleView.vue?vue&type=template&id=37fd7eb9&scoped=true"
import script from "./TraceabilitySampleView.vue?vue&type=script&lang=js"
export * from "./TraceabilitySampleView.vue?vue&type=script&lang=js"
import style0 from "./TraceabilitySampleView.vue?vue&type=style&index=0&id=37fd7eb9&prod&lang=scss&scoped=true"
import style1 from "./TraceabilitySampleView.vue?vue&type=style&index=1&id=37fd7eb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fd7eb9",
  null
  
)

export default component.exports